import React from 'react';
import { Link } from 'react-router-dom';
import { newsData } from '../data/newsData';
import { FaArrowRight } from 'react-icons/fa';
import './NewsPreview.css';

const NewsPreview = () => {
  // On ne prend que les 4 premiers articles pour l'accueil
  const latestNews = newsData.slice(0, 4);

  return (
    <section className="news-preview-section">
      <div className="news-container-fluid">
        
        {/* COLONNE GAUCHE : Image sombre / Vidéo style */}
        <div className="news-left-visual">
          <div className="visual-content">
            <h3>RESTONS CONNECTÉS</h3>
            <h2>DERNIÈRES <br/> ACTUALITÉS</h2>
            <Link to="/actualites" className="view-all-btn">
              VOIR TOUTES les actualités
            </Link>
          </div>
          <div className="blue-overlay"></div>
        </div>

        {/* COLONNE DROITE : Liste des articles */}
        <div className="news-right-list">
          {latestNews.map((item) => (
            <div className="news-item-row" key={item.id}>
              
              {/* Le carré Date (Flottant à gauche comme sur l'image ref) */}
              <div className="date-box">
                <span className="day">{item.date}</span>
                <span className="month">{item.month}</span>
              </div>

              {/* Le contenu Texte */}
              <div className="content-box">
                <h4>{item.title}</h4>
                <p>{item.excerpt.substring(0, 90)}...</p>
                <Link to={`/actualites/${item.id}`} className="read-more-link">
                  Lire la suite <FaArrowRight className="icon-small" />
                </Link>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NewsPreview;